<template>
    <div class="pop-activity">
        <div class="content" @click.stop="goTarget">
            <img :src="activity.photo_big.url">
            <div class="close" @click.stop="close">
                <img src="@/assets/img/+.svg">
            </div>
        </div>
        <div class="button" @click.stop="foreverClose">
            <img src="@/assets/img/circle.svg">
            不再顯示
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'PopActivity',
        props: {
          activity: {
              type: Object,
              require: true,
          }
        },
        methods: {
            close() {
                this.closeActivity(this.activity.id);
            },
            foreverClose() {
                let closeActivities = localStorage.getItem('close-activities');
                if (closeActivities) {
                    closeActivities = JSON.parse(closeActivities);
                } else {
                    closeActivities = [];
                }

                let activityId = this.activity.id;
                let index = closeActivities.findIndex(function(activity) {
                    return activity.id == activityId;
                })

                if (index < 0) {
                    closeActivities.push({
                        id: this.activity.id,
                        date: this.activity.ended_at,
                    });
                }

                localStorage.setItem('close-activities', JSON.stringify(closeActivities));
                this.close();
            },
            goTarget() {
                if (this.activity.type === 'url') {
                    window.open(this.activity.target, '_blank');

                    return;
                }

                let to = { name: 'home' };

                if (this.activity.type === 'shop') to = { name: 'shop', params: { id: this.activity.target } };
                if (this.activity.type === 'category') to = { name: 'ShopList', query: { title: this.activity.title, onlyCategory: this.activity.target } };
                if (this.activity.type === 'coupon') to = { name: 'coupons', query: { code: this.activity.target }};
                this.$router.push(to);
                this.close();
            },
            ...mapActions(['closeActivity']),
        }
    };
</script>

<style lang="scss" scoped>
    .pop-activity {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: fixed;
        background-color: rgba(0, 0, 0, .5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
        flex-direction: column;
        user-select: none;

        .content {
            position: relative;

            & img {
                height: 100%;
                max-height: 85vh;
                max-width: 85vw;
                user-select:none;
                pointer-events: none;
            }

            .close {
                position: absolute;
                top: 0;
                right: -15px;
                cursor: pointer;
            }
        }

        .button {
            margin-top: 5px;
            opacity: 0.93;
            border-radius: 15px;
            background-color: #4A4A4A;
            color: #FFFFFF;
            font-size: 14px;
            padding: 5px 25px;
            display: flex;
            cursor: pointer;

            img {
                margin-right: 5px;
            }
        }
    }
</style>
